import React from "react";

function CoreValueCard(props) {
    return (
        <div className="card agreement-core-value-card">
            <div className="card-header agreement-core-value-card-header">
                <img src={`${process.env.PUBLIC_URL}/images/${props.value.icon}`} alt={`${props.value.value} icon`}/>
                <div style={{ marginLeft: "10px" }}>
                    <h5>{props.value.value}</h5>
                    <p style={{ fontStyle: "italic" }}>"{props.value.slogan}"</p>
                </div>
            </div>
            <div className="card-body agreement-core-value-card-body">
                <ul>
                    {props.value.points.map((point) => (
                        <li>{point}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default CoreValueCard;